import { render, staticRenderFns } from "./MainSlide.vue?vue&type=template&id=ebca03f2&scoped=true&"
import script from "./MainSlide.vue?vue&type=script&lang=js&"
export * from "./MainSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebca03f2",
  null
  
)

export default component.exports